import request from "@/utils/request";

export function bind(bindKey) {
  return request({
    url: `/bind/${bindKey}`,
    method: 'post',
  })
}
